import script from "./role.vue?vue&type=script&setup=true&name=roleIndex&lang=js"
export * from "./role.vue?vue&type=script&setup=true&name=roleIndex&lang=js"

import "./role.vue?vue&type=style&index=0&id=1530b77c&lang=less"

const __exports__ = script;

export default __exports__